











































import {Component, Inject, Vue} from "vue-property-decorator";
import {mapGetters} from "vuex";
import {orderBy} from "lodash";
import Game from "@/model/Game";
import {PlayerRef} from "@/model/Player";
import {DataService} from "@/services/DataService";
import {MatchmakingService} from "@/services/MatchmakingService";

class PlayerCard {
    public ref!: PlayerRef;
    public participations!: number;
    public selected!: boolean;
    public mean!: number;

    constructor(ref: PlayerRef) {
        this.ref = ref;
        this.mean = 0;
        this.participations = 1;
        this.selected = false;
    }
}

@Component({
    computed: {
        ...mapGetters({
            games: "games"
        })
    }
})
export default class MatchMaking extends Vue {

    get selectedPlayers(): PlayerCard[] {
        return this.availablePlayers.filter((p) => p.selected);
    }
    @Inject("matchMakingService") public matchMakingService!: MatchmakingService;
    protected games!: Game[];
    private availablePlayers: PlayerCard[] = [];
    private team1: PlayerCard[] = [];
    private team2: PlayerCard[] = [];
    private matchmaking = false;
    private matchmakingDone = false;
    // Old guid of players (Vaas, pascual, louis, Angel)
    private excludedGuids: string[] = []; // "4d4cd333036a7cc46507cee2bac934c7", "454ed2957639a0dec24b1fa1ed4b0ae8", "ee37f4649620e4ab801fa0854caa2b98",
    // "90189ba6d585b3313ac24ff1df0a0f04", "debd6ca8825f665585b4a6e80850d555"];

    public created() {
        this.refreshPlayers();
    }

    public selectPlayer(p: PlayerCard) {
        p.selected = !p.selected;
    }

    public reset() {
        this.matchmakingDone = false;
        this.team1 = [];
        this.team2 = [];
        this.availablePlayers = [];
        this.refreshPlayers();
    }

    public launch() {
        this.matchmaking = true;
        this.computeTeams();
        setTimeout(() => {
            this.matchmaking = false;
            this.matchmakingDone = true;
        }, 3000);
    }

    private refreshPlayers() {
        const players: string[] = [];
        this.games.forEach((g) => {
            g.players.forEach((p) => {
                if (players.indexOf(p.playerRef.guid) === -1 && this.excludedGuids.indexOf(p.playerRef.guid) === -1) {
                    this.availablePlayers.push(new PlayerCard(p.playerRef));
                    players.push(p.playerRef.guid);
                } else if (players.indexOf(p.playerRef.guid) >= 0) {
                  const playerCard = this.availablePlayers.filter((_p) => _p.ref.guid === p.playerRef.guid)[0];
                  playerCard.ref.playerName = p.playerRef.playerName;
                  playerCard.participations++;
                }
            });
        });
        this.availablePlayers = orderBy(this.availablePlayers, ["participations"], ["desc"]);
        this.availablePlayers.forEach((p) => {
          p.mean = this.matchMakingService.computeEMP(p.ref.guid, this.games);
        });

    }

    private computeTeams() {
        const ladder = orderBy(this.selectedPlayers, ["mean"], ["desc"]);

        this.team1 = [];
        this.team2 = [];
        const opt1 = this.computeDiff(ladder, 3, 2);
        const opt2 = this.computeDiff(ladder, 2, 3);
        this.team1 = opt1[0] < opt2[0] ? opt1[1] as PlayerCard[] : opt2[1] as PlayerCard[];
        this.team2 = opt1[0] < opt2[0] ? opt1[2] as PlayerCard[] : opt2[2] as PlayerCard[];
    }

    private computeDiff(ladder: PlayerCard[], opt1: number, opt2: number) {
        const team1 = [];
        const team2 = [];
        team1.push(ladder[0], ladder[opt1]);
        team2.push(ladder[1], ladder[opt2]);
        for (let i = 4; i < ladder.length; i++) {
            if (i % 2 === 0) {
                team2.push(ladder[i]);
            } else {
                team1.push(ladder[i]);
            }
        }
        return [Math.abs(team1.map((t) => t.mean).reduce((a, b) => a + b, 0)
            - team2.map((t) => t.mean).reduce((a, b) => a + b, 0)), team1, team2];
    }
}
